import {Component, TextPropertyComponent} from 'substance'
import {Event} from '../../../../../lib/constants/Event'

import './scss/text.scss'

class TextComponent extends Component {
    didMount() {
        this.context.api.events.on(`textstyle-${this.props.node.id}`, Event.DOCUMENT_CHANGED, (event) => {
            if (!event.data || !event.data.data || !event.data.data.updated) {
                return
            }

            const nodeId = this.props.node.id
            const updatedNodes = event.data.data.updated

            for (const id in updatedNodes) {
                if (id === nodeId) {
                    return this.rerender()
                }
            }
        })
    }

    dispose() {
        this.context.api.events.off(
            `textstyle-${this.props.node.id}`, Event.DOCUMENT_CHANGED
        )
    }

    render($$, options) {
        return $$('div')
            .addClass('dw-text-container')
            .css({
                position: 'relative'
            })
            .append([
                this.renderLabel($$, options),
                this.renderTextContent($$, options)
            ])
    }

    renderLabel($$, options) {
        return $$('div')
            .attr('contenteditable', 'false')
            .addClass(options.labelClassName ? `dw-text-label ${options.labelClassName}` : 'dw-text-label')
            .append([
                $$('div')
                    .attr('contenteditable', 'false')
                    .append(options.shortLabel),
                $$('div')
                    .attr('contenteditable', 'false')
                    .append(options.longLabel)
            ])
    }

    renderTextContent($$, options) {
        let classNames = `dw-text ${options.textClassName}`
        if (!this.props.node.content) {
            classNames += ' dw-text-placeholder'
        }

        return $$('div')
            .addClass(classNames)
            .attr({
                'data-id': this.props.node.id,
                'data-placeholder': options.longLabel
            })
            .append(
                $$(TextPropertyComponent, {
                    path: [this.props.node.id, 'content']
                })
            )
    }
}

export {TextComponent}
